module.exports = __webpack_public_path__ + "static/providus-00b664fb41b1f2600d3535a0fdcc6787.png";